import { Col } from 'reactstrap';
import styled, { keyframes } from 'styled-components';

export const ModalContainer = styled.div`
    background-color: ${ ({ theme: { notificationModalColor } }) => notificationModalColor };
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    height: ${ ({ height }) => height ? height : '360px' };
    max-width: ${ ({ maxWidth }) => maxWidth || 'auto' };
    padding: ${ ({ padding }) => padding };
    width: 360px;
`;

export const Row = styled.div`
    padding: ${ ({ padding }) => padding || 0 };
    align-items: center;
    display: flex;
    justify-content: center;
`;

export const Text = styled.div `
    color: ${ ({ theme: { secondaryColor, opacityColor }, opacity }) => opacity ? opacityColor : secondaryColor };
    display: block;
    font-size: ${ ({ size }) => size || '13px' };	
    line-height: ${ ({ lineHeight }) => lineHeight || '16px' };
    margin: ${ ({ margin }) => margin || '20px 0' };
    text-align: ${ ({ textAlign }) => textAlign || 'center' };
`;

export const StyledCol = styled(Col)`
    align-items: center;
    display: flex;
    gap: 20px;
    justify-content: center;
`;

export const Title = styled.div `
    color: ${ ({ theme: { secondaryColor, opacityColor }, opacity }) => opacity ? opacityColor : secondaryColor };
    display: block;
    font-size: ${ ({ size }) => size || '26px' };	
    line-height: ${ ({ lineHeight }) => lineHeight || '32px' };
    margin: ${ ({ margin }) => margin || '5px 0' };
    padding: ${ ({ padding }) => padding || '35px 0px 0px 0px' };
    text-align: ${ ({ textAlign }) => textAlign || 'center' }
`;
